import create_mocked_environment from '../graphql/create_environment';
import {
  emails,
  users as names,
  authorized_apps,
  properties,
  roles
} from './mocks';

import { DateTime } from 'luxon';

//const default_cursor = 0;
//const default_last_cursor = 336 - 15;


function mock_role(roles) {
  return roles[
      Math.floor(
        Math.random() * roles.length
      )
    ];
}

function mock_auth_appps(authorized_apps) {
  const {length: l} = authorized_apps;
  const start = Math.floor(Math.random() * l);
  const end = Math.round((Math.random() * l) + start);
  return authorized_apps.slice(start, end).map(name => ({ name }));
}

function handlePagination({
  first,
  last,
  after,
  before
}) {

    const startCursor = first ? +after : +before - last;
    const endCursor = first ? +after + first : +before;
    return {
      startCursor: `${startCursor}`,
      endCursor: `${endCursor}`,
      hasNextPage: first ? emails.length > endCursor : true,
      hasPreviousPage: first ? true : startCursor > last
    }
}


let cache = {};

function generate_mock_contacts({
  first,
  last,
  after = "0",
  before = "336"
}) {

  console.log("generate_mock_contacts - first: ", first, "after: ",after, "before: ",before,"last: ",last);
  const {
    startCursor,
    endCursor,
    hasNextPage,
    hasPreviousPage
  } = handlePagination({ first, after, before, last });

  return {
    pageInfo: {
      startCursor,
      endCursor,
      hasPreviousPage,
      hasNextPage
    },
    totalCount: emails.length,
    edges: emails.slice(startCursor, endCursor).map((email, idx) => {
      const [first_name, last_name] = names[+startCursor+idx].split(' ');

      cache[email] = cache[email] || {
        role: mock_role(roles),
        authorizedApps: mock_auth_appps(authorized_apps),
        lastLogin: DateTime.local().minus({ days: Math.floor(Math.random() * 50) }).toISO()
      };

      return {
        node: {
          id: `contact-id-${idx}`,
          first_name,
          last_name,
          email,
          ...cache[email]
        }
      }
    })
  }
}

export default {
    types: {
     Org: () => ({
       id: 'orgID',
       name: 'Abe Residental',
       createdAt: new Date(),
       suborgs: (root, {name}) => [],
       regions: () => [],
       role: () => [],
       accounts: async(root, { first, after, before, last }) => {
         console.log("first: ", first, "after: ",after, "before: ",before,"last: ",last);
         return generate_mock_contacts({ first, after, before, last });
       }
     }),
    },
    query: {
      account: async(root, { id }, idx) => {
        return {
          id,
          first_name: 'Admin',
          last_name: 'User',
          email:'admin@hy.ly',
          authorizedApps: [{
            name: 'Accounts',
            access: 'admin'
          }]
        }
      },
    //  org: async() => ({

      //})
    }
};
